import styled from '@emotion/styled';
import { TextField } from '@mui/material';

export const StyledTextField = styled(TextField)`
  & .MuiInputBase-input {
    height: 50px !important;
    overflow: auto !important;
  }
`;
